import { apiClient } from "@/core/api/httpClient";

export default {
  getReport: (type, payload) => {
    return apiClient.post(`/trend-reports/${type}`, payload);
  },
};
